import "./Image.css"
function Image() {
  return (
    <div>
      <img
        className="img-sample"
        alt="Cute little cat"
        src="https://images.unsplash.com/photo-1533743983669-94fa5c4338ec?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=983&q=80"
      />
    </div>
  );
}

export default Image;
